export const addDofollowToAnchors = (html = "") => {
  if (typeof window === "undefined") return html; // ensure client-only

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const anchors = doc.querySelectorAll("a");

  anchors.forEach((a) => {
    const href = a.getAttribute("href") || "";
    if (href.startsWith("http")) {
      a.setAttribute("rel", "dofollow");
      a.removeAttribute("target", "_blank");
    }
  });

  return doc.body.innerHTML; // return modified innerHTML
};
